import { CustomAction } from 'model/state';
import {
  CHANGE_VALVE_STATE, CHANGE_VALVE_STATE_SUCCESS, CHANGE_VALVE_STATE_ERROR, SET_DEVICE_SYSTEM_MODE,
  SET_DEVICE_SYSTEM_MODE_SUCCESS, SET_DEVICE_SYSTEM_MODE_ERROR, UPDATE_DEVICE, UPDATE_DEVICE_ERROR,
  UPDATE_DEVICE_SUCCESS, DELETE_DEVICE, DELETE_DEVICE_ERROR, DELETE_DEVICE_SUCCESS, RUN_HEALTH_TEST, FETCH_DEVELOPER_MENU_SETTINGS, FETCH_DEVELOPER_MENU_SETTINGS_SUCCESS, FETCH_DEVELOPER_MENU_SETTINGS_ERROR, UPDATE_DEVELOPER_MENU_SETTINGS, UPDATE_DEVELOPER_MENU_SETTINGS_SUCCESS, UPDATE_DEVELOPER_MENU_SETTINGS_ERROR, CHANGE_DEVELOPER_MENU_SETTINGS
} from 'constants/ActionTypes';
import { ValveState, DeviceSystemMode, Device, DeveloperMenuSettings } from 'model';

/**
 * Payload
 */
export interface DevicePayload {
  target?: ValveState;
  deviceId?: string;
  systemMode?: DeviceSystemMode;
  device?: Partial<Device>;
}

export interface DeveloperMenuPayload {
  settings?: DeveloperMenuSettings;
  deviceId?: string;
}

/**
 * Actions
 */
export const changeValveState = (deviceId: string, target: ValveState): CustomAction<DevicePayload> => {
  return {
    type: CHANGE_VALVE_STATE,
    payload: { target, deviceId }
  };
};

export const changeValveStateSuccess = (): CustomAction<DevicePayload> => {
  return {
    type: CHANGE_VALVE_STATE_SUCCESS,
  };
};

export const changeValveStateError = (): CustomAction<DevicePayload> => {
  return {
    type: CHANGE_VALVE_STATE_ERROR,
  };
};

export const setDeviceSystemMode = (deviceId: string, systemMode: DeviceSystemMode): CustomAction<DevicePayload> => {
  return {
    type: SET_DEVICE_SYSTEM_MODE,
    payload: { deviceId, systemMode }
  };
};

export const setDeviceSystemModeSuccess = (): CustomAction<DevicePayload> => {
  return {
    type: SET_DEVICE_SYSTEM_MODE_SUCCESS,
  };
};

export const setDeviceSystemModeError = (): CustomAction<DevicePayload> => {
  return {
    type: SET_DEVICE_SYSTEM_MODE_ERROR,
  };
};

export const deleteDevice = (deviceId: string): CustomAction<DevicePayload> => {
  return {
    type: DELETE_DEVICE,
    payload: {
      deviceId
    }
  };
};

export const deleteDeviceSuccess = (): CustomAction<DevicePayload> => {
  return {
    type: DELETE_DEVICE_SUCCESS
  };
};

export const deleteDeviceError = (): CustomAction<DevicePayload> => {
  return {
    type: DELETE_DEVICE_ERROR
  };
};

export const updateDevice = (deviceId: string, device: Partial<Device>): CustomAction<DevicePayload> => {
  return {
    type: UPDATE_DEVICE,
    payload: {
      deviceId,
      device,
    }
  };
};

export const updateDeviceSuccess = (): CustomAction<DevicePayload> => {
  return {
    type: UPDATE_DEVICE_SUCCESS
  };
};

export const updateDeviceError = (): CustomAction<DevicePayload> => {
  return {
    type: UPDATE_DEVICE_ERROR
  };
};

export const updateDeveloperMenuSettings = (deviceId: string, settings: DeveloperMenuSettings): CustomAction<DeveloperMenuPayload> => {
  return {
    type: UPDATE_DEVELOPER_MENU_SETTINGS,
    payload: {
      deviceId,
      settings,
    }
  };
};

export const changeDeveloperMenuSettings = (settings: DeveloperMenuSettings): CustomAction<DeveloperMenuPayload> => {
  return {
    type: CHANGE_DEVELOPER_MENU_SETTINGS,
    payload: {
      settings,
    }
  };
};

export const updateDeveloperMenuSettingsSuccess = (): CustomAction<DeveloperMenuPayload> => {
  return {
    type: UPDATE_DEVELOPER_MENU_SETTINGS_SUCCESS
  };
};

export const updateDeveloperMenuSettingsError = (): CustomAction<DeveloperMenuPayload> => {
  return {
    type: UPDATE_DEVELOPER_MENU_SETTINGS_ERROR
  };
};

export const runHealthTest = (deviceId: string): CustomAction<DevicePayload> => {
  return {
    type: RUN_HEALTH_TEST,
    payload: { deviceId }
  };
};

export const fetchDeveloperMenuSettings = (deviceId: string): CustomAction<DeveloperMenuPayload> => {
  return {
    type: FETCH_DEVELOPER_MENU_SETTINGS,
    payload: { deviceId }
  };
};

export const fetchDeveloperMenuSettingsSuccess = (settings: DeveloperMenuSettings): CustomAction<DeveloperMenuPayload> => {
  return {
    type: FETCH_DEVELOPER_MENU_SETTINGS_SUCCESS,
    payload: { settings }
  };
};

export const fetchDeveloperMenuSettingsError = (): CustomAction<DeveloperMenuPayload> => {
  return {
    type: FETCH_DEVELOPER_MENU_SETTINGS_ERROR,
  };
};
